import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import type { EmailTemplate } from '@/types/outreach';

const KEYS = {
  all: ['templates'] as const,
  list: () => [...KEYS.all, 'list'] as const,
};

export const useTemplates = () => {
  return useQuery<EmailTemplate[]>({
    queryKey: KEYS.list(),
    queryFn: async () => {
      const { data } = await api.get(API_ROUTES.emailTemplates);
      return data.results || data;
    },
  });
};

export const useSaveTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (template: EmailTemplate) => {
      if (template.id) {
        const { data } = await api.put(`${API_ROUTES.emailTemplates}${template.id}/`, template);
        return data;
      }
      const { data } = await api.post(API_ROUTES.emailTemplates, template);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: KEYS.all });
    },
  });
};
